import {
  Component, ViewEncapsulation, AfterViewInit, OnDestroy, Input, ComponentFactory,
  ViewChild, ViewContainerRef, ComponentRef, Inject, ElementRef, Output, ReflectiveInjector, Renderer2
} from "@angular/core";
import {StringUtils} from "../../shared/services/stringutils";
import {DynamicTypeBuilder, IHaveDynamicData} from "../../shared/type-builder/type.builder";
import {BehaviorSubject} from "rxjs";
import {ReplaySubject} from "rxjs/ReplaySubject";

declare var scrollMonitor: any;

@Component({
  templateUrl: './articlecontent.component.html',
  styleUrls: [ './articlecontent.component.scss' ],
  selector: 'articlecontent',
  encapsulation: ViewEncapsulation.None
})

export class ArticleContentComponent implements AfterViewInit, OnDestroy {

  @ViewChild('content', {read: ViewContainerRef}) public contentContainer: ViewContainerRef;
  protected componentRef: ComponentRef<IHaveDynamicData>;

  protected _article = new BehaviorSubject<any>([]);

  @Input()
  set article(value) { this._article.next(value); }
  get article() { return this._article.getValue(); }

  @Output()
  protected onVisible: ReplaySubject<any>;


  constructor(protected stringUtils: StringUtils,
              protected typeBuilder: DynamicTypeBuilder,
              @Inject('isBrowser') protected isBrowser: boolean) {
    this.onVisible = new ReplaySubject<any>();
  }

  ngAfterViewInit() {
    this._article
      .subscribe(article => {
        if(article != null) {
          this.renderContent(article);
        }
      });
  }

  public renderContent(article: any) {

    if (this.componentRef) {
      this.componentRef.destroy();
    }

    let content = this.stringUtils.unescapeTransferStateCacheData(article['content']);

    this.typeBuilder.createComponent(content, this.contentContainer)
      .then(componentRef => {
        this.componentRef = componentRef;
        if(this.isBrowser) {
          let contentWatcher = scrollMonitor.create(this.componentRef.location.nativeElement, {
            top: -300,
            bottom: -300
          });
          contentWatcher.enterViewport(() => {
            this.onVisible.next(article);
          });
        }
      });


  }

  public ngOnDestroy(){
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/article/articlecontent/articlecontent.component.ts